import { render } from "./UPLOAD.vue?vue&type=template&id=97732506&scoped=true"
import script from "./UPLOAD.vue?vue&type=script&lang=js"
export * from "./UPLOAD.vue?vue&type=script&lang=js"

import "./UPLOAD.vue?vue&type=style&index=0&id=97732506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97732506"]])

export default __exports__